<template>
<v-row justify="center" class="border-radius-3">
    <v-dialog
        v-model="dialog"
        persistent
        width="850"
        :retain-focus="false"
        overlay-color="primary"
        overlay-opacity="0.95"
    >    
        <v-card class="border-radius-3 py-5 border-radius-1" style="background: white;">
            <v-card-title class=" d-flex justify-center">
                <p
                    class="titles py-3 d-flex justify-center flex-column"
                    v-html="$t('initialTour.categories_select')">
                </p>
            </v-card-title>
            <v-container class=" height-viewport-100">
                <div class="d-flex justify-content category-content">
                    <v-row class="pa-0 ma-0 main-categories">
                        <v-col
                            data-cy="select-category"
                            cols="3"
                            md="2"
                            v-for="(category, index) of categories"
                            :key="index"
                            class="pa-0 ma-2"
                        >
                            <Category :data="category" :selected="isCategorySelected(category)" :key="reload"></Category>
                        </v-col>
                    </v-row>
                </div>
            </v-container>
            <v-card-actions class="d-flex justify-center">
                <v-row class="ma-0">
                    <v-col cols="5" md="4" offset-md="2">
                        <v-btn
                            color="primary"
                            class="no-uppercase border-radius-1"
                            large
                            block
                            outlined
                            @click="closeModal"
                            :disabled="btnLoading"
                        >
                            {{ $t('profile.leave') }}
                        </v-btn>
                    </v-col>
                    <v-col cols="7" md="4">
                        <v-btn
                            data-cy="save-changes-categories-btn"
                            color="secondary"
                            class="no-uppercase bg-gradient-primary border-radius-1"
                            dark
                            large
                            block
                            @click="updateCategories"
                            :loading="btnLoading"
                        >
                            {{ $t('profile.save_changes') }}
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-actions>
        </v-card>
    </v-dialog>
    </v-row>
</template>

<script>

import { mapActions, mapState } from 'vuex'
import UserService from '@/services/users'
import Category from '../onBoarding/CategoriesCore/Category.vue'

export default {
    props: {
        dialog: { type: Boolean, default: false },
    },
    components:{
        Category,
    },
    data() {
        return {
            btnLoading: false,
            reload: 0,
            select_categories: [],
            selectedCategoriesObj: []
        }
    },
    computed: {
        ...mapState(['categories']),
        ...mapState({
            stCategories: (state) => state.userData.selectedCategories,
            stUserAvatar: (state) => state.userData.avatarSelected,
            stUser: (state) => state.userData.user,
            survey: (state) => state.userData.survey,
        }),
        username() {
            return `${this.user.firstname.split(' ')[0]} ${this.user.lastname.split(' ')[0]}`
        }
    },
    methods: {
        ...mapActions('dashboard', [
            'showCategories',
            'showAvatars',
            'showInitialPoll',
            'mountDiagnostic',
            'showFinishPreferencesModal',
        ]),
        ...mapActions('userData', ['changeCategories']),
        closeModal () {
            this.$emit('close')
            this.reload += 1
        },
        isCategorySelected(category) {
            const exists = this.stCategories.find(categorySelected => category.id === categorySelected.id)
            return typeof exists !== 'undefined'
        },
        searchCategorySelected(categoryId) {
            return this.categories.find(categorySelected => Number(categoryId) === Number(categorySelected.id))
        },
        async updateCategories() {
            const vm = this
            vm.select_categories = []
            vm.selectedCategoriesObj = []
            document.querySelectorAll('.category-active').forEach((obj) => {
                const id = obj.getAttribute('data-category-id')
                const category = this.searchCategorySelected(id)
                vm.select_categories.push(id)
                vm.selectedCategoriesObj.push(category)
            })

            this.changeCategories(this.selectedCategoriesObj)

            this.btnLoading = true
            await this.updateUserPreferences({
                userId: this.stUser.id,
                avatar: this.stUserAvatar.id,
                userAvatar: this.stUserAvatar.id,
                categories: this.select_categories,
            })
            this.btnLoading = false
        },
        updateUserPreferences(data) {
            return new Promise((resolve, reject) => {
                UserService.updateUserPreferences(data)
                    .then((response) => {
                        resolve(response)
                        this.closeModal()
                    })
                    .catch((err) => {
                        console.error(err)
                        reject(err)
                    })
            })
        }
    }
}
</script>

<style lang="scss">
.color-primary {
    color: #514773;
}
.color-name {
    color: #4A3216;
}
.no-uppercase {
     text-transform: none;
}

.category-content {
    height: 50vh;
    overflow: auto;
}

.main-categories {
    justify-content: center;
    align-items: self-start;
    align-content: start;
}

.category-img {
    display: block;
    max-width: 52vh;
    height: 65px;
}

.sm-category-img {
    display: block;
    max-width: 52vh;
    height: 4vh;
}

.category-active .category-box {
    border: 6px solid #7764CA;
}

.category-check {
    display: none;
}
.category-active .category-check {
    bottom: -12px;
    right: 0px;
    display: flex;
    position: absolute;
    justify-content: center;
    align-items: center;
}

.category-active .sm-category-img {
    height: 5vh;
}
.titles{
  color: #323A46;
  font-size: 1.75rem;
  b{
    font-weight: 700;
  }
  @media screen and (max-width: 600px) {
    font-size: 1.2rem;
  }
}
</style>